module.exports = __webpack_public_path__ + "static/img/img_2.fe78ce2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/code/img_2.jpg
// module id = 94
// module chunks = 20